import __base_store from '@/store/__base_store'

/**
 * Store de planes (modelo `plan`) construido desde el factory común.
 */
export default __base_store({
	state: {
		model_name: 'plan',
	},
})

